import React, { useState, useEffect } from 'react';
import { Info } from './Styles';
import { STATUS_MONITORING } from './TranslationValues';

import { useSubscription } from '@apollo/client';

import { withTranslation } from 'react-i18next';
import ApprovalDashboardModal from './Component/ApprovalDashboardModal';
import ModalForJobQueue from './Component/JOBQueueModal';
import ActionOverviewCard from './ActionOverviewCard';
import {
  ApprovalModal,
  JOBQueueModal,
  JobProcessingModal,
  PrintingModal,
  PrintingQueue, PrintingCenter,
  ControlCenter
} from '../../../utils/complexDocumentConstants';
import { FETCH_BATCHES, FETCH_HYBRID_AUDIT } from '../gql/FetchBatches';
import PrintingQueueModal from './Component/PrintingQueueModal';
import { getChannelTotals } from '../../../utils/helper';

const NAMESPACES = ['STATUS_MONITORING'];

const StatusMonitoringInfo = ({ jobId, filters, t, users, subscribed }) => {
  const [showArrows, toggleShowArrows] = useState(false);
  const [modalType, setModalType] = useState('');
  const [isModalOpen, setModalOpen] = useState('');
  const [loading, setLoading] = useState(false);

  const { data, loading: dataLoading, error } = useSubscription(FETCH_BATCHES, {
    variables: {
      filter: { page: 1, startDate: filters?.filter?.startDate, endDate: filters?.filter?.endDate, jobId, batchType: filters?.filter?.batchType, isArchived: filters?.filter?.isArchived  },
    },
    skip: false,
    shouldResubscribe: true,
  });

  const { data: hybridData } = useSubscription(FETCH_HYBRID_AUDIT, {
    variables: { batchId: jobId },
    skip: false,
    shouldResubscribe: true,
  });

  let activeItem = data?.batchDocumentStats?.data ? data.batchDocumentStats?.data[0] : undefined;
  const isHybrid = activeItem?.batchType === 'HYBRID';
  const hybridCounts = hybridData?.hybridBatchFullStats?.data?.counts;
  const {email:emailCount} = getChannelTotals(activeItem?.batchStats || [], false, t, false);

  const localizedKeys = {
    ApprovalModal: t(
      STATUS_MONITORING.APPROVAL_ENGINE_MODAL.key,
      STATUS_MONITORING.APPROVAL_ENGINE_MODAL.value,
    ),
    PrintingModal:
      emailCount > 0
        ? t(
            STATUS_MONITORING.DELIVERY_MODAL_TITLE.key,
            STATUS_MONITORING.DELIVERY_MODAL_TITLE.value,
          )
        : t(
            STATUS_MONITORING.PRINTING_MODAL_TITLE.key,
            STATUS_MONITORING.PRINTING_MODAL_TITLE.value,
          ),
    JobProcessingModal: t(
      STATUS_MONITORING.JOB_PROCESSING_CENTER_TITLE.key,
      STATUS_MONITORING.JOB_PROCESSING_CENTER_TITLE.value,
    ),
    JobQueueModal: t(
      STATUS_MONITORING.JOB_QUEUE_MODAL_TITLE.key,
      STATUS_MONITORING.JOB_QUEUE_MODAL_TITLE.value,
    ),
    PrintingQueue: t(
      STATUS_MONITORING.PRINTING_QUEUE_MODAL_TITLE.key,
      STATUS_MONITORING.PRINTING_QUEUE_MODAL_TITLE.value,
    ),
    PrintingCenter: t(
      STATUS_MONITORING.PRINTING_CENTER_MODAL_TITLE.key,
      STATUS_MONITORING.PRINTING_CENTER_MODAL_TITLE.value,
    ),
    ControlCenter: t(
      STATUS_MONITORING.CONTROL_CENTER_MODAL_TITLE.key,
      STATUS_MONITORING.CONTROL_CENTER_MODAL_TITLE.value,
    ),
  };

  useEffect(() => {
    setLoading(true);
    toggleShowArrows(false);
    setTimeout(() => {
      setLoading(false);
      setTimeout(() => {
        toggleShowArrows(true);
      }, 1000);
    }, 1000);
  }, [jobId]);


  if (isHybrid && hybridCounts) {
    activeItem = {
      ...activeItem,
      printQueueCount: hybridCounts.sentCount,
      batchStats: [
        {
          ...activeItem.batchStats[0],
          failureCount: hybridCounts.generationFailedCount,
          successCount: hybridCounts.generatedCount,
          totalCount: hybridCounts.totalCount,
        },
      ],
    };
  }

  return (
    <Info showArrows={showArrows}>
      {dataLoading || loading || activeItem === undefined ? (
        <div
          style={{
            display: 'flex',
            height: '100%',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={'tech_loader.gif'} style={{ width: '100px' }} alt="" />
        </div>
      ) : (
        <>
          {/* {activeItem?.requiresApproval && (
            <p className="approval-status">
              {t(
                STATUS_MONITORING.APPROVAL_REQUIRED_LABEL.key,
                STATUS_MONITORING.APPROVAL_REQUIRED_LABEL.value,
              )}
            </p>
          )} */}
          <ActionOverviewCard
            setModalType={type => {
              setModalType(type);
              setModalOpen(type);
            }}
            activeItem={activeItem}
            users={users}
          />

          <ApprovalDashboardModal
            visible={
              isModalOpen === ApprovalModal ||
              isModalOpen === PrintingModal ||
              isModalOpen === JobProcessingModal
            }
            onCancel={() => setModalOpen('')}
            title={localizedKeys[modalType]}
            contentType={modalType}
            activeItem={activeItem}
            jobId={jobId}
            users={users}
            subscribed={subscribed}
          />

          <ModalForJobQueue
            visible={isModalOpen === JOBQueueModal}
            title={localizedKeys[modalType]}
            onCancel={() => setModalOpen('')}
            activeItem={activeItem}
            contentType={modalType}
            users={users}
            jobId={jobId}
          />

          <PrintingQueueModal
            visible={isModalOpen === PrintingQueue || isModalOpen === PrintingCenter || isModalOpen === ControlCenter}
            onCancel={() => setModalOpen('')}
            title={localizedKeys[modalType]}
            contentType={modalType}
            activeItem={activeItem}
            jobId={jobId}
            users={users}
            subscribed={subscribed}
          />
        </>
      )}
    </Info>
  );
};

export default withTranslation(NAMESPACES)(StatusMonitoringInfo);
